import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { SalesBrochureHTML } from '../components/SalesBrochureHTML';

export function SalesPDFPage() {
  const contentRef = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: 'Prixia-Material-de-Ventas',
  });

  return (
    <div className="min-h-screen bg-slate-100">
      {/* Toolbar */}
      <div className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200 px-6 py-3 flex items-center justify-between print:hidden">
        <div>
          <h1 className="text-lg font-bold text-slate-900">Material de Ventas</h1>
          <p className="text-xs text-slate-500">Brochure comercial — Prixia</p>
        </div>
        <button
          onClick={() => handlePrint()}
          className="px-5 py-2.5 text-sm font-semibold text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition shadow-sm cursor-pointer"
        >
          Descargar PDF
        </button>
      </div>

      {/* Content */}
      <div className="flex justify-center py-8 print:py-0">
        <div ref={contentRef}>
          <SalesBrochureHTML />
        </div>
      </div>
    </div>
  );
}
